import React from "react";

interface SummaryIconProps {
  color?: string;
  width?: number;
  height?: number;
  background?: string;
}

const EofyButtonIcon = (props: SummaryIconProps) => {
  const { width, height, background } = props;
  return (
    <div style={{ display: "flex", paddingTop: "2px" }}>
      <svg
        width={width ? width : "32"}
        height={height ? height : "32"}
        viewBox={width && height ? `${width / 2} ${height / 2} ${width} ${height} ` : "0 0 32 32"}
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <rect width="32" height="32" rx="16" fill={background ? background : "#CCC3AE"} />
        <path
          d="M18 23.4994H20.1053M18 23.4994V21.745M18 23.4994H16.1053C15.989 23.4994 15.8947 23.4051 15.8947 23.2889V21.9555C15.8947 21.8392 15.989 21.745 16.1053 21.745H18M20.1053 23.4994V19.2889M20.1053 23.4994H22C22.1163 23.4994 22.2105 23.4051 22.2105 23.2889V17.3941C22.2105 17.2778 22.1163 17.1836 22 17.1836H20.3158C20.1995 17.1836 20.1053 17.2778 20.1053 17.3941V19.2889M18 21.745V19.4994C18 19.3831 18.0943 19.2889 18.2105 19.2889H20.1053"
          stroke="white"
          strokeWidth="0.789474"
        />
        <path
          d="M21.8931 16.75V11.3114C21.8931 11.192 21.8445 11.0776 21.7579 10.9932L19.3346 8.63181C19.248 8.54741 19.1306 8.5 19.0081 8.5H10.0407C9.7857 8.5 9.57895 8.70147 9.57895 8.95V23.05C9.57895 23.2985 9.7857 23.5 10.0407 23.5H17.2753"
          stroke="white"
          strokeWidth="0.789474"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.8146 8.5V11.05C18.8146 11.2985 19.0213 11.5 19.2764 11.5H21.8931"
          stroke="white"
          strokeWidth="0.789474"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default EofyButtonIcon;
